/* ---- Ghost putts (2026-09-25 mode map) ---- */

interface GhostBallEvent {
  kind: 'putt';
  ghost?: boolean;
  color?: string | null;
}

interface GhostBallScene {
  kind: 'putt';
  ballColor: string;
}

/**
 * The stage paints the rolling ball in `scene.ballColor`. A ghost event (an
 * opponent's recorded putt) rolls in its own color, so the scene handed to
 * the stage swaps the ball color for the duration of that event and reverts
 * the moment a non-ghost event or a null event follows. Pure so the swap is
 * testable without WebGL.
 */
export function stageSceneForEvent<S extends GhostBallScene>(
  scene: S | null | undefined,
  event: GhostBallEvent | null | undefined,
): S | null | undefined {
  if (!scene || scene.kind !== 'putt') return scene;
  if (!event || event.kind !== 'putt' || event.ghost !== true) return scene;
  const color = event.color?.trim();
  if (!color) return scene;
  return { ...scene, ballColor: color };
}
